export const FORM_MODES = {
  CREATE: 'create',
  EDIT: 'edit'
} as const;

export type FormMode = (typeof FORM_MODES)[keyof typeof FORM_MODES];

const VALIBOT_EXPECTED_NUMBER_EMPTY = 'Invalid type: Expected number but received ""';
const VALIBOT_EXPECTED_NUMBER_NULL = 'Invalid type: Expected number but received null';

const VALIBOT_EXPECTED_STRING_NULL = 'Invalid type: Expected string but received null';

const VALIBOT_TYPE_ERROR_KEYS: Record<string, string> = {
  [VALIBOT_EXPECTED_NUMBER_EMPTY]: 'courseForm.validation.expectedNumber',
  [VALIBOT_EXPECTED_NUMBER_NULL]: 'courseForm.validation.expectedNumber',
  [VALIBOT_EXPECTED_STRING_NULL]: 'courseForm.validation.expectedString'
};

export const translateErrorMessage = (error: unknown): string => {
  if (!error) {
    return '';
  }

  if (typeof error === 'string') {
    return VALIBOT_TYPE_ERROR_KEYS[error] ?? error;
  }

  if (typeof error === 'object' && error !== null && 'message' in error) {
    const message = (error as { message: unknown }).message;
    if (typeof message === 'string') {
      return VALIBOT_TYPE_ERROR_KEYS[message] ?? message;
    }
  }

  return 'errors.genericError';
};
